export const generationOptions = [
  {
    value: 13,
    label: '13ª Geração',
    bloodPool: { max: 10, perTurn: 1 },
    attributeMax: 5,
    disciplineMax: 5
  },
  {
    value: 12,
    label: '12ª Geração',
    bloodPool: { max: 11, perTurn: 1 },
    attributeMax: 6,
    disciplineMax: 6
  },
  {
    value: 11,
    label: '11ª Geração',
    bloodPool: { max: 12, perTurn: 1 },
    attributeMax: 6,
    disciplineMax: 6
  },
  {
    value: 10,
    label: '10ª Geração',
    bloodPool: { max: 13, perTurn: 1 },
    attributeMax: 6,
    disciplineMax: 6
  },
  {
    value: 9,
    label: '9ª Geração',
    bloodPool: { max: 14, perTurn: 2 },
    attributeMax: 7,
    disciplineMax: 6
  },
  {
    value: 8,
    label: '8ª Geração',
    bloodPool: { max: 15, perTurn: 3 },
    attributeMax: 8,
    disciplineMax: 7
  }
]

export const qualityOptions = [
  { id: 'acute-senses', name: 'Sentidos Aguçados', cost: 1, description: 'Escolha um sentido que recebe +2 em testes relacionados.' },
  { id: 'iron-will', name: 'Vontade de Ferro', cost: 3, description: 'Bônus de +3 contra Dominação e efeitos que alterem a mente.' },
  { id: 'efficient-digestion', name: 'Digestão Eficiente', cost: 2, description: 'Cada ponto de sangue ingerido conta como dois para nutrição.' },
  { id: 'innocence', name: 'Inocência', cost: 1, description: 'Dificuldade reduzida para testes sociais com mortais crédulos.' },
  { id: 'lucky', name: 'Sortudo', cost: 3, description: 'Permite repetir um teste mal sucedido por sessão.' },
  { id: 'common-sense', name: 'Senso Comum', cost: 1, description: 'O Narrador pode oferecer dicas quando você está prestes a agir sem pensar.' },
  { id: 'light-sleeper', name: 'Sono Leve', cost: 2, description: 'Você acorda facilmente durante o dia com testes de dificuldade reduzida.' },
  { id: 'prestigious-sire', name: 'Progenitor Prestigioso', cost: 3, description: 'Aliados e Status adicionais devido à fama do seu criador.' },
  { id: 'true-faith', name: 'Fé Verdadeira', cost: 4, description: 'Possui 1 ponto de Fé Verdadeira.' },
  { id: 'iron-stamina', name: 'Resistência Admirável', cost: 2, description: 'Recebe -2 de dificuldade em testes para resistir à dor ou penalidades de ferimentos.' }
]

export const defectOptions = [
  { id: 'dark-secret', name: 'Segredo Obscuro', points: 1, description: 'Um segredo perigoso que pode arruinar sua não-vida se for descoberto.' },
  { id: 'enemy', name: 'Inimigo', points: 1, description: 'Um inimigo ativo procura prejudicá-lo sempre que possível.' },
  { id: 'short-fuse', name: 'Pavio Curto', points: 2, description: 'Dificuldade reduzida para entrar em Fúria; você é facilmente provocado.' },
  { id: 'haunted', name: 'Assombrado', points: 3, description: 'Assombrações causam penalidades ocasionais e interferem com ações diárias.' },
  { id: 'addiction', name: 'Vício', points: 2, description: 'Dependência química ou comportamental que exige testes frequentes.' },
  { id: 'suspicious', name: 'Desconfiado', points: 1, description: 'Dificuldade aumentada em testes sociais baseados em confiança.' },
  { id: 'hunted', name: 'Caçado', points: 4, description: 'Caçadores sabem que você existe e perseguem você ativamente.' },
  { id: 'phobia', name: 'Fobia', points: 2, description: 'Medo intenso que pode imobilizá-lo em situações específicas.' },
  { id: 'dark-past', name: 'Passado Sombrio', points: 1, description: 'Seu passado inclui crimes hediondos ou atos inconfessáveis.' },
  { id: 'repulsive', name: 'Repulsivo', points: 3, description: 'Penalidades severas em testes sociais presenciais.' }
]

export const MAX_DEFECT_POINTS = 7

export const ATTRIBUTE_PRIORITY_POINTS = Object.freeze({
  primary: 7,
  secondary: 5,
  tertiary: 3
})

export const ABILITY_PRIORITY_POINTS = Object.freeze({
  primary: 13,
  secondary: 9,
  tertiary: 5
})

export const BONUS_COSTS = Object.freeze({
  attributes: 5,
  abilities: 2,
  disciplines: 7,
  backgrounds: 1
})
